import React from 'react';
import MainLayout from '../layouts/MainLayout';

const MainLayoutWrapper = ({ isDarkMode, toggleTheme, children }) => {
  return (
    <MainLayout isDarkMode={isDarkMode} toggleTheme={toggleTheme}>
      {children}
    </MainLayout>
  );
};

export default MainLayoutWrapper;
